export default __webpack_public_path__ + "static/media/cotizacion.f9c7560b.png";